import { extend } from 'flarum/common/extend';
import passwordless from './passwordless';

/** Sem senha, o "Definir senha" do editar usuário (forum e admin) só seria apagado no servidor. */
export default function extendEditUserModal() {
  extend('flarum/common/components/EditUserModal', 'fields', function (items) {
    if (passwordless()) items.remove('password');
  });
}
flarum.reg.add('ramon-magic-link', 'common/extendEditUserModal', extendEditUserModal);